import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetQuestionnaireTagsDTO } from '../../dto/questionnaires'
import { store } from '../../store'
import { createCall } from '../base'
import { BASE_METHODS } from '../base/base.constants'
import { GET_QUESTIONNAIRES_ACTIONS } from './questionnaires.constants'

export const getQuestionnaireTags = async () => {

    const promise = createCall(`questionnaires/tag`, BASE_METHODS.GET)
    promise.then(async response => {

        let body: GetQuestionnaireTagsDTO

        try {
            body = plainToClass( GetQuestionnaireTagsDTO, JSON.parse( await response.text() ) )
        } catch ( exception ) {
            store.dispatch( { type: GET_QUESTIONNAIRES_ACTIONS.GET_QUESTIONNAIRE_TAG_INVALID_JSON } )
            return
        }
    
        if ( ( await validate( body ) ).length > 0 ) {
            store.dispatch( { type: GET_QUESTIONNAIRES_ACTIONS.GET_QUESTIONNAIRE_TAG_INVALID_RESPONSE } )
            return
        }
    
        store.dispatch( { type: GET_QUESTIONNAIRES_ACTIONS.GET_QUESTIONNAIRE_TAG_OK, questionnaireTags: body.questionnaireTags } )

    })

    promise.catch(error => {
        store.dispatch( { type: error } )
    })

}